<template>
  <div class="upload-file">
    <template v-if="loading">
      <div class="text-xs-center">
        <sync-loader :color="$vuetify.theme.primary" :size="'10px'"></sync-loader>
      </div>
    </template>
    <div class="text-xs-center" v-else @click="onClickUploadButton">
      <slot>
        <v-btn small color="primary">
          <span class="fa fa-camera mr-1"></span>
          {{ $t('select file to upload') }}
        </v-btn>
        <div class="caption grey--text">
          {{ $t('upload file size: {size}MB', { size: 10 }) }}
        </div>
      </slot>
    </div>

    <input
      type="file"
      class="form-control-file pt-2"
      name="photoUpload"
      :id="'photoUploadInput' + objId"
      data-vv-as="File"
      v-validate="'image|size:10240|mimes:image/jpeg,image/png,image/jpg,image/gif'"
      accept=".jpg, .png, .jpeg, .gif"
      @change="onFileChange($event)"
      style="overflow: hidden; position: fixed; width: 1px; height: 1px; z-index: -1; opacity: 0"
    />
  </div>
</template>
<script>
import UploadSingleFile from './UploadSingleFile.js'
export default {
  mixins: [UploadSingleFile]
}
</script>



// WEBPACK FOOTER //
// src/components/elements/UploadFileButton.vue